<!-- 隐私条款 -->
<template>
  <div class="border">
    <div>
      <el-card body-style="padding: 20px 0">
        <div class="main-title">
          Find Our Products In Local Stores
        </div>
        <div  v-if="this.$data.localStoreList.length != 0">
          <div class="swiper-container">
            <div class="swiper-prev retailers-swiper-prev el-icon-arrow-left" slot="button-prev"></div>
            <swiper id="swiper1" style="margin-top: 40px;" :options="localStoreSwiperOption">
              <swiper-slide v-for="(item, key) in localStoreList" :key="key">
                <div class="card-detail">
                  <div class="card-img"><img :src="item.img" @click="preImg(item,true)"></div>
                  <span class="bold">{{ item.storeName }}</span>
                  <span class="address-font" @click="preImg(item,false)"><span class="el-icon-location-outline"></span>{{ item.storeAddress
                    }}</span>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-next retailers-swiper-next el-icon-arrow-right" slot="button-next"></div>
          </div>
        </div>

        <div class="footer">
          Powered by ShopVidi
        </div>
      </el-card>
    </div>

    <el-dialog
      :show-close="true"
      :visible.sync="visible"
      class="brand-details"
      destroy-on-close
      :width="IS_MOBILE?'100%':'70%'"
      :close-on-click-modal="false">
      <div class="vilocal-dialog">
        <div class="describe">
            <p>{{curItm.storeName}}</p>
            <div>
                <i class="el-icon-location"></i>
                <div>{{curItm.storeAddress}}</div>
            </div>
            <hr>
            <p>
              {{curItm.description}}
            </p>
            <p>Powered by ShopVidi</p>
        </div>
        <div class="pre-img-content">
          <!-- 预览图 -->
          <div class="pre-img-top">
            <i class="el-icon-arrow-left" :style="preOriginalIdx==0?'opacity: 0.35':''" @click="preOriginalIdx>0?preOriginalIdx--:preOriginalIdx"></i>
            <el-image class="pre-original-img" :src="preOriginalImg"></el-image>
            <i class="el-icon-arrow-right"
               :style="(curItm['imgList']&&preOriginalIdx==curItm['imgList'].length-1)?'opacity: 0.35':''"
               @click="(curItm['imgList'] && curItm['imgList'].length-1)>preOriginalIdx?preOriginalIdx++:preOriginalIdx"></i>
          </div>

          <!-- 浏览小图 -->
          <div class="pre-img-bottom">
            <i class="el-icon-arrow-left smail-img-swiper-prev" :style="preOriginalIdx==0?'opacity: 0.35':''"  slot="button-prev"></i>
            <div class="small-img">
              <swiper class="swiper" ref="swiper3"
                      :options="IS_MOBILE?smailStoreSwiperOptionMobile:(smailStoreSwiperOption)">
                  <swiper-slide v-for="(item, key) in curItm['imgList']" :key="'swiperSlide'+key">
                     <div :class="{'small-img-active':key==preOriginalIdx,'small-img-inactive':key!==preOriginalIdx}" @click="clickSmailImg(item,key)">
                      <img :class="{'small-img-width':getImgAbbr(item),'small-img-height':!getImgAbbr(item)}" :src="item" :key="'img'+key" >
                     </div>
                  </swiper-slide>
                </swiper>

            </div>
            <i class="el-icon-arrow-right smail-img-swiper-next"  :style="(curItm['imgList']&&preOriginalIdx==curItm['imgList'].length-1)?'opacity: 0.35':''" slot="button-next"></i>
          </div>

        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getAction } from '@/api/manage'
// 引入插件
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import '../pages/home/swiper3.1.3.css'
// import awesomeSwiper from '../pages/home/components/awesomeSwiper'

export default {
  name: 'Vilocal',
  components: {
    swiperSlide,
    swiper
    // awesomeSwiper
  },
  data() {
    return {
      brandMap: {
        'xikezan': 10,
        'goiple': 11,
        'fulllight-tech': 13,
        'vgr': 14,
        'ella-s-ear': 15,
        'voltrx': 16,
        'gathertop': 17,
        'bison-denim': 18,
        'reoria': 19,
        'mandydress': 20,
        'sevich': 21,
        'tsbling': 22,
        'rosalind': 23,
        'cheerla': 24,
        'niidor': 26,
        'mointo': 29,
        'shivpiin': 30,
        'shanuoint': 31,
        'vanitii': 32,
        'aokitec': 40,
        'gaovot': 170
      },
      localStoreSwiperOption: {
        slidesPerView: 3,
        direction: 'horizontal',
        navigation: {
          nextEl: '.retailers-swiper-next',
          prevEl: '.retailers-swiper-prev'
        }
      },
      smailStoreSwiperOptionPcArr: [],
      smailStoreSwiperOption: {
        // 开启动态检查器
        observer: true,
        slidesPerView: 5,
        // slidesPerGroup: 3,
        // loop: false,
        spaceBetween: 5,
        direction: 'horizontal',
        navigation: {
          nextEl: '.smail-img-swiper-next',
          prevEl: '.smail-img-swiper-prev'
        }
        /*    on: {
          resize: () => { //窗口变化
            let that = this
            setTimeout(() => {
              debugger
              let swiper = that.$refs.swiper3.$swiper;
              //更新Swiper，相当于初始化
              swiper.update();
            }, 500);//延时器很重要，不加可能会出错
          },
        }, */

      },
      smailStoreSwiperOptionMobile: {
        slidesPerView: 4,
        spaceBetween: 5,
        direction: 'horizontal',
        navigation: {
          nextEl: '.smail-img-swiper-next',
          prevEl: '.smail-img-swiper-prev'
        }
      },
      turnPages: true,
      pagination: false,
      isPc: false, // pc
      isApp: false, // 手机
      loading: false,
      visible: false,
      appLocalStoreList: [],
      localStoreList: [],
      preOriginalImg: '', // 预览图
      preOriginalIdx: '', // 预览图下标
      curItm: '',
      slidesPerViewMain: 1, // 主图每页展示多少，默认是1
      spaceBetweenMain: 20 // 主图间距，默认是20
    }
  },
  created() {
    let brand = this.$route.params.brand

    if (brand !== null || brand !== undefined) {
      // brand = brand.toLowerCase()
      // brandCode = this.brandMap[brand]

      getAction('/vilocal/shop/order/api/v0.2/config/brands/' + brand).then(res => {
        // // Our Retailers
        this.localStoreList = res.result.map(itm => {
          if (itm['imgList']) {
          /*  itm['imgList'] = JSON.parse(JSON.stringify(itm['imgList']))
            console.log(itm['imgList'], "???") */
          }
          return itm
        })
        this.swiperSettings()
      })
    }

    for (let i = 1; i <= 5; i++) {
      let slidePcObj = {
        observer: true,
        slidesPerView: i,
        // slidesPerGroup: 3,
        // loop: false,
        spaceBetween: 5,
        direction: 'horizontal',
        navigation: {
          nextEl: '.smail-img-swiper-next',
          prevEl: '.smail-img-swiper-prev'
        }
      }
      this.smailStoreSwiperOptionPcArr.push(slidePcObj)
    }
  },
  methods: {
    getImgAbbr(fileDetail) {
      const preImgtemp = fileDetail
      let imgObject = this.getImgSize(preImgtemp)
      return imgObject.width > imgObject.height
    },
    async getImgSize (url) {
      return new Promise((resolve, reject) => {
        let imgObj = new Image()
        imgObj.src = url
        imgObj.onload = () => {
          resolve({
            width: imgObj.width,
            height: imgObj.height
          })
        }
      })
    },
    swiperSettings() {
      this.screenWidth = document.body.clientWidth
      this.screenHeight = document.body.clientHeight
      if (this.screenWidth < 600) {
        this.slidesPerViewMain = 1
        this.localStoreSwiperOption = {
          slidesPerView: this.slidesPerViewMain,
          // spaceBetween: 20,
          direction: 'horizontal',
          navigation: {
            nextEl: '.retailers-swiper-next',
            prevEl: '.retailers-swiper-prev'
          }
        }
        this.isPc = false
        this.$nextTick(() => {
          this.isApp = true
        })
      } else if (this.screenWidth > 1900) {
        this.slidesPerViewMain = 4
        if (this.localStoreList.length < 4) {
          this.slidesPerViewMain = this.localStoreList.length
          this.spaceBetweenMain = 100
        }
        this.localStoreSwiperOption = {
          slidesPerView: this.slidesPerViewMain,
          spaceBetween: this.spaceBetweenMain,
          direction: 'horizontal',
          navigation: {
            nextEl: '.retailers-swiper-next',
            prevEl: '.retailers-swiper-prev'
          }
        }
      } else if (this.screenWidth > 1500 && this.screenWidth <= 1900) {
        this.slidesPerViewMain = 4
        if (this.localStoreList.length < 4) {
          this.slidesPerViewMain = this.localStoreList.length
          this.spaceBetweenMain = 100
        }
        this.localStoreSwiperOption = {
          slidesPerView: this.slidesPerViewMain,
          spaceBetween: this.spaceBetweenMain,
          direction: 'horizontal',
          navigation: {
            nextEl: '.retailers-swiper-next',
            prevEl: '.retailers-swiper-prev'
          }
        }
      } else {
        this.isApp = false
        this.$nextTick(() => {
          this.isPc = true
        })
      }
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth
          this.screenHeight = document.body.clientHeight
          if (this.screenWidth < 420) {
            this.isPc = false
            this.$nextTick(() => {
              this.isApp = true
            })
          } else {
            this.isApp = false
            this.$nextTick(() => {
              this.isPc = true
            })
          }
        })()
      }
    },
    preImg(itm, isClickImg) {
      this.preOriginalIdx = -1

      this.$nextTick(() => {
        this.curItm = {...itm}
        this.preOriginalIdx = isClickImg ? 0 : this.curItm['imgList'].length - 1
        this.visible = true

        this.smailStoreSwiperOption['slidesPerView'] = 5
        this.smailStoreSwiperOptionMobile['slidesPerView'] = 4
        let imgListLen = this.curItm['imgList'].length
        if (imgListLen < 5) {
          this.smailStoreSwiperOption['slidesPerView'] = imgListLen
        }
        if (imgListLen < 4) {
          this.smailStoreSwiperOptionMobile['slidesPerView'] = imgListLen
        }
      })
    },
    clickSmailImg(itm, i) {
      this.preOriginalIdx = i
      this.preOriginalImg = itm
    }

  },
  watch: {
    preOriginalIdx: {
      handler(n, o) {
        console.log(n)
        if (n > -1) {
          this.preOriginalImg = this.curItm['imgList'][n]

          let that = this
          this.$nextTick(() => {
            // 先销毁
            that.$refs.swiper3.swiper.destroy()
            // 在加载
            that.$refs.swiper3.mountInstance()

            // 到指定postion
            that.$refs.swiper3.swiper.slideTo(n)
          })
        }
      }
    }

  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
#swiper1{
  width: 95%;
}
/deep/ .el-card.is-always-shadow{
box-shadow: 0px 0px 10px rgba(0,0,0,0.05) !important;
}
.card-img{
  width: 372px;
  height: 279px;
  img{
    border-radius: 5px !important;
    width: 100%;
    height: 100%;
    object-fit:cover;
    cursor:pointer;
  }
}
.card-detail{
  width: 372px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin:0 auto;
}
/* haoyaunw add 2021-10-15  begin*/

.app-title{
  display: flex;
  justify-content: center;
  align-items: center;
  margin:27px 0 30px 0;
}
.app-retailers-pagination {
  position: absolute;
  left: 50%;
  bottom: -px;
  /* 向下偏移的距离，根据需要进行调整 */
  transform: translateX(-50%);
  /* 居中对齐 */
}

.swiper-container {
  display: flex;
  // flex-direction: row;
  align-items: center;
  // justify-content: space-between
}

.border {
  margin: 0 auto;
  width: 100%;
  height: 100%;
}

.footer {
  display: flex;
  justify-content: flex-end;
  margin-right:24px;
  height: 17px;
  font-size: 12px;
  font-family: Satoshi;
  font-weight: 400;
  line-height: 24px;
  color: #8F8F8F;
  opacity: 1;
  margin-top: 24px;
}
.footer-app {
  display: flex;
  justify-content: center;
  height: 17px;
  font-size: 14px;
  font-family: Satoshi;
  font-weight: 400;
  line-height: 24px;
  color: #8F8F8F;
  opacity: 1;
}

.bold {
  margin-top: 10px;
  height: 17px;
  font-size: 14px;
  font-family: Satoshi;
  font-weight: bold;
  line-height: 24px;
  color: #262B2F;
  opacity: 1;
}

/deep/ .input-with-select .el-input__inner {
  outline: none;
  border: 1px solid #E1E1E1;
}

/deep/ .el-input__inner {
  outline: none;
  border: 1px solid #E1E1E1;
  font-family: Satoshi-Regular !important;
}

/deep/ .el-textarea__inner {
  outline: none;
  border: 1px solid #E1E1E1;
  font-family: Satoshi-Regular !important;
}

/deep/ .el-input--suffix {
  background: #FFFFFF;
  color: #171A32;
  font-weight: 500;
  /* border-bottom: 1px solid #E1E1E1;
  border-top: 1px solid #E1E1E1; */
}

.main-title {
  font-family: Satoshi-Medium;
  text-align: center;
  font-size: 30px;
}

.swiper-prev {
  width: 20px !important;
  height: 58px;
  color: white;
  background-color: #262613;
  display: flex;
  align-items: center;
  border-radius: 0px 6px 6px 0px;
  font-size: 20px;
}

.swiper-next {
  width: 20px !important;
  height: 58px;
  color: white;
  background-color: #262613;
  display: flex;
  align-items: center;
  border-radius: 6px 0px 0px 6px;
  font-size: 20px;
}

.swiper-prev.swiper-button-disabled,
.swiper-next.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}

.address-font {
  margin-top: 10px;
  font-family: Satoshi;
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #262613;
  text-decoration: underline;
  opacity: 1;
  cursor:pointer;
}

/deep/ .gm-style-iw {
  padding: 0 !important;
  margin: 0 !important;
}

/deep/ .gm-style .gm-style-iw-d {
  overflow: hidden !important;
}

/deep/ .gm-style-iw button {
  display: none !important;
}

.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/deep/.swiper-pagination-bullet {
  margin-left: 8px;
}

/deep/ .swiper-pagination-bullet-active {
  background: black;
}
.brand-details{
  height:497.5px;
  overflow: hidden;
  /deep/ .el-icon-close:before{
      color: #FFFFFF !important;
  }
  /deep/ .el-dialog{
    margin-top: 0px !important;
  }
  .vilocal-dialog{
    height:497.5px;
    overflow: hidden;
    display: flex;
    box-sizing: border-box;
    position: relative;
  }
  .describe{
    flex-grow: 1;
    width: 25%;
    padding: 25px 15px;
    background: #262B2F;
    color: #FFFFFF;
    position: relative;
    p:nth-child(1){
      font-size: 18px;
      font-weight: bold;
      margin-top: 25px;
    }

    hr{
      border-width: 0.5px !important;
    }

    >div:nth-child(2){
      display: flex;
      margin-top: 15px;
      justify-content: space-between;
      margin-bottom: 20px;
      i{font-size: 22px !important;}
      div:nth-child(2){margin-left: 5px;}
    }
    p:nth-child(4){
      margin-top: 10px;
    }
    p:nth-child(5){
      position: absolute;
      color: #8F8F8F;
      font-size: 12px;
      bottom: 15px;
    }
  }

  .pre-img-content{
    flex-grow: 1;
    padding-bottom:15px;
    width: 75%;
    background: #262B2F;
    opacity: 0.92;
    i{
      cursor: pointer;
      color: #FFFFFF;
    }
    .pre-img-top,.pre-img-bottom{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .pre-img-top{
      margin-top: 21px;
      i{
        font-size: 28px !important;
      }
      .pre-original-img{
        width: 530px;
        height: 390px;
        margin: 0 20px;
        display: flex;
        justify-content: center;
        /deep/ .el-image__inner{
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

    }

    .pre-img-bottom {
      margin-top: 10px;
      i {
        font-size: 20px !important;
      }
      .small-img {
        width: 450px;
        display: flex;
        flex-shrink: 0;
      }

      .small-img-active,.small-img-inactive{
        border: 1px solid #FFFFFF;
        width: 70px;
        height: 60px;
        display: flex;
        justify-content: center;
        margin: 0 5px;
        cursor:pointer;
        img{
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .small-img-inactive{
        border: 1px solid #676060;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .card-detail{
    width: 335px;
  }
  .card-img{
    width: 335px;
    height: 251.25;
  }
  .home {
    background-color: #f7f5f4;
    padding-top: 20px;
    min-width: auto;
  }

  .main-title {
    font-family: Satoshi-Medium;
    text-align: center;
    font-size: 24px;
  }

  .footer_margin {
    margin-top: 220px !important;
  }

  .content6-about {
    width: 90vw !important;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around
  }

  .main-content-form {
    box-shadow: none;
    background: none;
    width: 100%;
    padding-bottom: 0px;
  }

  .head-txt {
    line-height: 30px;
    text-align: center;
    padding-bottom: 15px;
  }

  .head-txt-phone2 {
    margin-top: 20px;
  }

  .contact-content {
    width: 50vw;
  }

  .main-content {
    width: 100vw;
    margin-top: 45px;
  }

  // haoyuanw add 2021-10-15 begin
  .main-content-footer {
    margin-top: 250px;
    flex-direction: column;
    align-items: flex-start;
  }

  .main-content-footer-email,
  .main-content-footer-address,
  .main-content-footer-phone {
    flex-direction: row;
    margin: 0px;
    margin-left: 20px;
  }

  .main-content-footer-email-content,
  .main-content-footer-address-content,
  .main-content-footer-phone-content {
    text-align: left;
    margin-left: 20px;
    margin-top: 0px
  }

  .head-main {
    position: absolute;
    background: url("../assets/mobile-bg-1x.png");
    background-position: center center;
    // background-color: #FFFFFF;
    background-size: contain;
    background-repeat: no-repeat;
    width: 385px;
    left: 0px;
    top: calc(100vh + 250px);
    right: 0px;
    height: 152px;
  }

  .main-head {
    background-color: #ffffff;
    border-top: 4px #ececec solid;
  }

  /deep/ .select-phone .el-input--suffix {
    width: 23vw;
  }

  .main-basic-content {
    margin: 0px;
    margin-top: 10px;
    margin-left: 10%;
    line-height: 80px;
    border-bottom: 1px #e6e4e3 solid;
    text-align: left;
    width: 85%;
  }

  .introduce-icon {
    display: inline-block;
    vertical-align: initial;
  }

  .introduce-text {
    display: inline-block;
    margin-left: 30px;
    line-height: 36px;
    height: 70px;
    width: calc(100% - 33px)
  }

  .brand-details{
    min-height: 590px !important;

    /deep/ .el-dialog__headerbtn{
      right: 0px !important;
      top: 0px !important;
      font-size: 24px;
      background: #262B2F;
    }
    .vilocal-dialog{
      min-height: 590px !important;
      .pre-img-content{
        width: 100% !important;
        .pre-img-top{
          margin-top: unset;
          i{
            font-size: 28px !important;
            position: absolute;
            z-index: 99;
            &:nth-child(1){
              left: 5px;
            }
            &:nth-child(3){
              right: 5px;
            }
          }
          .pre-original-img{
            width: 100% !important;
            height: 280px !important;
            margin: unset !important;
          }

        }
        .small-img{
          width: 83% !important;
        }
      }

      .describe{
        width: 95% !important;
        position: absolute  !important;
        top: 370px !important;
        z-index: 2;
        p:nth-child(1){
          margin-top: 5px;
        }
        >div:nth-child(2){
          justify-content: left;
        }
        p:nth-child(5){
          text-align: right;
          margin-top: 15px;
          position: unset !important;
        }

      }

    }
  }

}

@media only screen and (min-width: 1597px) and (max-width: 1697px) {
  .head-main {
    left: 130px !important;
  }
}

@media only screen and (min-width: 1437px) and (max-width: 1537px) {
  .head-main {
    left: 30px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ViLocal.vue